module.exports = __webpack_public_path__ + "res/26-img_card_bg.974f52859d22e7e04194281ba9f140bd.png";